import {Component, EventEmitter, inject, Input, Output} from '@angular/core';
import {EventItem} from "../../common/interfaces";
import {SmallCardComponent} from "./small-card/small-card.component";
import {NgOptimizedImage} from "@angular/common";
import {LanguageService} from "../../services/language.service";
import {NewAllEventsComponent} from "./new-all-events/new-all-events.component";

@Component({
  selector: 'app-new-events-list',
  standalone: true,
  imports: [SmallCardComponent, NgOptimizedImage, NewAllEventsComponent],
  templateUrl: './new-events-list.component.html',
  styleUrl: './new-events-list.component.sass'
})
export class NewEventsListComponent {
    @Input() eventsList!: EventItem[];
    @Input() currentOrderEventId: any | null = null;
    @Output() selectEvent = new EventEmitter<EventItem>();

    private readonly languageService = inject(LanguageService);
    readonly currentLang = this.languageService.currentLanguage;

    handleSelectEvent = (event: EventItem): void => {
      this.selectEvent.emit(event);
    };
}
